(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function (e) {
  var schedule = document.getElementById('rfitness-schedule');
  var myClass = document.getElementById('myClass'); // wyłącznie dla szablonu jupiter

  var headerJupiter = document.querySelector('.jupiterx-header');
  var classes = document.querySelectorAll('.schedulesClass');
  /**
   * Odpowiada za amianę w filtrze rodzaj zajęć
   * @type {HTMLElement}
   */

  var selectCalendarType = document.getElementById('calendar_type_select');
  selectCalendarType.addEventListener('change', function (event) {
    var typeName = {
      type: event.target.value
    };
    ustawianieAdresuURLFiltr(typeName);
  });
  /**
   * Odpowiada za zmianę w filtrze instruktorzy
   * @type {HTMLElement}
   */

  var selectInstructorSelect = document.getElementById('calendar_instructor_select');
  selectInstructorSelect.addEventListener('change', function (event) {
    var instructor = {
      instructor: event.target.value
    };
    ustawianieAdresuURLFiltr(instructor);
  });
  /**
   * Odpowiada za zmianę w filtrze room Pokuj zajęć
   * @type {HTMLElement}
   */

  var selectRoomSelect = document.getElementById('calendar_room_select');
  selectRoomSelect.addEventListener('change', function (event) {
    var room = {
      room: event.target.value
    };
    ustawianieAdresuURLFiltr(room);
  });

  var _loop = function _loop() {
    var field = _Array$from[_i];
    field.addEventListener('click', function (e) {
      e.preventDefault(); // zbiera niezbędne dane

      var data = {
        'clubId': field.getAttribute("data-club"),
        'classId': field.getAttribute("data-class"),
        'action': field.getAttribute("data-action")
      }; // console.log(data);

      /**
       * https://gist.github.com/cwhittl/015827973d23ce657bfe09c735c9fa98
       * @type {FormData}
       */

      var form = new FormData();
      form.append('action', data.action);
      form.append('clubId', data.clubId);
      form.append('classId', data.classId);
      form.append('nonce', schedule.querySelector('[name="nonce"]').value);
      var params = new URLSearchParams(form); // zapisuje adres url z form

      var url = schedule.dataset.url; // console.log(data);
      // console.log(url);
      // let params = new FormData(schedule);
      // console.log(params);
      // http://kursjs.pl/kurs/ajax/fetch.php

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Cache-Control': 'no-cache'
        },
        body: params
      }).then(function (res) {
        return res.json();
      })["catch"](function (err) {
        console.log(err);
      }).then(function (response) {
        // console.log(response);
        // włącza block z dodatkowymi informacjami o Class
        myClass.style.display = "block";
        headerJupiter.style.zIndex = '10';
        /**
         * Rozdziela pozyskana datę na godzinę i datę
         * Następnie dopisuje nazwę dnia tygodnia
         * a w godzinie usuwa sekundy
         * @type {*|string[]}
         */

        var separateDate = response.startDate.split("T");
        var days = ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'];
        var d = new Date(separateDate[0]);
        separateDate[0] = days[d.getDay()] + ', ' + separateDate[0];
        separateDate[1] = separateDate[1].slice(0, -3);
        myClass.querySelector('.rfitness-class-name').innerHTML = response.classDefinitionName; // ma za zadanie przyciąć tekst w opisie zajęć i dodanie przycisku more

        if (response.classDefinitionDescription) {
          myClass.querySelector('.modal-body').innerHTML = skracanieTresci(response.classDefinitionDescription, 200, response.classDefinitionId);
        }

        myClass.querySelector('.class-instructor').innerHTML = response.instructorName; // myClass.querySelector('.class-instructor-desc').innerHTML=response.instructorDescription;
        // ma za zadanie przyciąć tekst w opisie instruktora i dodanie przycisku more używając do tego id instructora

        if (response.instructorDescription) {
          myClass.querySelector('.class-instructor-desc').innerHTML = skracanieTresci(response.instructorDescription, 300, response.instructorId);
        }

        if (response.instructorPhotoUrl) {
          myClass.querySelector('.rfitness-instructor-img').src = response.instructorPhotoUrl;
        }

        myClass.querySelector('.rfitness-startDate').innerHTML = separateDate[0];
        myClass.querySelector('.rfitness-startHour').innerHTML = separateDate[1];
        myClass.querySelector('.rfitness-duration').innerHTML = response.duration;
        /**
         * Tworzenie linków dla instruktora i potem dla typu zajęć
         */

        var instruktorid = document.getElementById('calendar_other_instructor').getAttribute('href') + response.instructorId;
        document.getElementById('calendar_other_instructor').href = instruktorid;
        var classDefinitionId = document.getElementById('calendar_other_class').getAttribute('href') + response.classDefinitionId;
        document.getElementById('calendar_other_class').href = classDefinitionId;
        /**
         * Odpowiada za przycisk more dla instruktora
         */

        if (response.instructorDescription) {
          // https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_read_more
          var classInstructorMore = myClass.querySelector('.class-instructor-desc');
          var instructorDOT = classInstructorMore.querySelector('.moreellipses' + response.instructorId);
          var instructorMoreText = classInstructorMore.querySelector('.morecontent' + response.instructorId);
          var instructorMoreLink = classInstructorMore.querySelector('.morelink' + response.instructorId);
          instructorMoreLink.addEventListener('click', function (e) {
            e.preventDefault();

            if (instructorDOT.style.display === 'none') {
              instructorDOT.style.display = 'inline';
              instructorMoreLink.innerHTML = "Czytaj więcej";
              instructorMoreText.style.display = 'none';
            } else {
              instructorDOT.style.display = 'none';
              instructorMoreText.style.display = 'inline';
              instructorMoreLink.innerHTML = "Mniej";
            }
          });
        }
        /**
         * Odpowiada za przycisk more dla opisu zajęć
         */


        if (response.classDefinitionDescription) {
          var classDefinitionDescriptionMore = myClass.querySelector('.modal-body');
          var DefinitionDescriptionDOT = classDefinitionDescriptionMore.querySelector('.moreellipses' + response.classDefinitionId);
          var DefinitionDescriptionMoreText = classDefinitionDescriptionMore.querySelector('.morecontent' + response.classDefinitionId);
          var DefinitionDescriptionMoreLink = classDefinitionDescriptionMore.querySelector('.morelink' + response.classDefinitionId);
          DefinitionDescriptionMoreLink.addEventListener('click', function (e) {
            e.preventDefault();
            console.log(e);

            if (DefinitionDescriptionDOT.style.display === 'none') {
              DefinitionDescriptionDOT.style.display = 'inline';
              DefinitionDescriptionMoreLink.innerHTML = "Czytaj więcej";
              DefinitionDescriptionMoreText.style.display = 'none';
            } else {
              DefinitionDescriptionDOT.style.display = 'none';
              DefinitionDescriptionMoreText.style.display = 'inline';
              DefinitionDescriptionMoreLink.innerHTML = "Mniej";
            }
          });
        }
        /**
         * Odpowiada za przycisk zamykania po wyświetleniu okna
         * @type {Element}
         */


        var span = document.getElementsByClassName('close')[0];
        span.addEventListener('click', function (e) {
          myClass.style.display = "none";
          myClass.querySelector('.rfitness-instructor-img').src = '/wp-content/plugins/rfitness/assets/img/szarapostac.png';
          myClass.querySelector('.modal-body').innerHTML = '';
          myClass.querySelector('.class-instructor-desc').innerHTML = ''; // wyłącznie dla szablonu jupiter

          headerJupiter.style.zIndex = '100';
        });
      });
    });
  };

  for (var _i = 0, _Array$from = Array.from(classes); _i < _Array$from.length; _i++) {
    _loop();
  }
});

function ustawianieAdresuURLFiltr(selected) {
  // console.log(selected);
  var url = window.location.href;
  var daneURL = window.location.search;
  var filtrowaneDane = '';

  if (selected.type) {
    filtrowaneDane += '&type=' + selected.type;
  }

  if (selected.instructor) {
    filtrowaneDane += '&instructor=' + selected.instructor;
  }

  if (selected.room) {
    filtrowaneDane += '&room=' + selected.room;
  }

  if (daneURL) {
    window.location.href = url + filtrowaneDane;
  } else {
    window.location.href = url + '?' + filtrowaneDane;
  } // console.log(daneURL);
  // todo TEMP zmień to przeładowanie na przeładowanie z parametrami
  // return url;

}
/**
 * Ma za zadanie podzielić treść na dwie części
 * @param tresc
 * @param cutoff
 * @returns {string}
 */


function skracanieTresci(tresc, cutoff) {
  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";

  if (cutoff == null) {
    var _cutoff = 100;
  }

  var text = tresc;
  var rest = text.substring(cutoff);

  if (text.length > cutoff) {
    var period = rest.indexOf('...');
    var space = rest.indexOf(' ');
    cutoff += Math.max(Math.min(period, space), 0);
  } // Assign the rest again, because we recalculated the cutoff


  rest = text.substring(cutoff);
  var visibleText = tresc.substring(0, cutoff);
  visibleText += '<span class="moreellipses' + id + '" style="display: inline;">...&nbsp;</span>'; // visibleText += '<span class="morecontent">';

  visibleText += '<span class="morecontent' + id + '" style="display: none;">';
  visibleText += tresc.substring(cutoff);
  visibleText += '</span>';
  visibleText += '<a href="#" class=".left morelink' + id + '">Więcej</a>'; // visibleText += '</span>';

  return visibleText;
}

},{}]},{},[1]);
